module.exports = __webpack_public_path__ + "static/undraw_team_spirit_hrr4-5a3343ff69cdcdaca6096e23e4c1226e.svg";